module.exports = __webpack_public_path__ + "static/img/b2_footer.7d3cc55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/core/b2_footer.png
// module id = 19VC
// module chunks = 1